import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../../services/tracking';

function detectEntity(pathname) {
  const parts = pathname.split('/').filter(Boolean);
  if (parts[0] === 'product' && parts[1]) {
    return { entity_type: 'product', entity_id: parts[1] };
  }
  if (parts[0] === 'category' && parts[1]) {
    return { entity_type: 'category', metadata: { slug: parts[1] } };
  }
  if (parts[0] === 'subcategory' && parts[1]) {
    return { entity_type: 'subcategory', metadata: { slug: parts[1] } };
  }
  if (parts[0] === 'brand' && parts[1]) {
    return { entity_type: 'brand', metadata: { slug: parts[1] } };
  }
  if (parts[0] === 'preinvoice') {
    return { entity_type: 'preinvoice', entity_id: parts[1] || null };
  }
  return { entity_type: 'page' };
}

export default function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.search;
    const entity = detectEntity(location.pathname);
    trackPageView({
      path,
      title: document.title || '',
      ...entity,
    });
  }, [location.pathname, location.search]);

  return null;
}
